<template>
  <Modal v-model="showpdf" style="opacity: 1;" :mask-closable="false" :scrollable="true"
    @on-visible-change="visibleChange" :footer-hide="true" width="1476">
    <div slot="header">下载报告</div>
    <div class="pdf-body" ref="detail">
      <div class="head">
        <!-- <img :src="headImg" class="img-head" alt="" srcset=""> -->
        <span>
          估价报告
        </span>
        <!-- <img :src="headImg" class="img-head" style="transform: rotateZ(180deg)" alt="" srcset=""> -->
      </div>
      <!-- 估价结果 -->
      <div class="result">
        <Row :gutter="16" index="">
          <Col span="13">
          <div class="top">
            <div class="title">
              {{ assessmentDetail.evlTitle }}
            </div>
            <div class="msg">
              <div class="time">提交时间：{{ assessmentDetail.createTime | filter_assessTime }}</div>
            </div>
          </div>
          <div class="center-box">
            <div class="flex-box">
              <div class="left-box" v-if="(assessmentDetail.assessResult == 1)">
                <PriceBox :price="assessmentDetail.evaluateTotalPrice.toFixed(2)" title="总价" unit="万"></PriceBox>
                <PriceBox :price="assessmentDetail.evaluatePrice.toFixed(0)" title="单价" unit="元/㎡" :isBlue="false">
                </PriceBox>
              </div>
              <div class="left-box" v-if="(assessmentDetail.assessResult == 3)">
                <PriceBox :price="assessmentDetail.evaluateTotalPrice.toFixed(2)" title="参考总价" :isYellow="true"
                  unit="万元">
                </PriceBox>
                <PriceBox :price="assessmentDetail.evaluatePrice.toFixed(0)" title="参考单价" :isYellow="true" unit="元/㎡"
                  :isBlue="false">
                </PriceBox>
              </div>
              <div class="no-price" v-if="(assessmentDetail.assessResult == 2)">暂无估价</div>
              <div class="no-price" v-if="(assessmentDetail.assessResult == 0)">

                估价中
              </div>

            </div>



          </div>
          <div class="detail">
            <div class="item">
              <div class="box">
                <div class="msg">
                  面积:
                </div>
                <span class="units" v-if="assessmentDetail.buildingArea">{{ assessmentDetail.buildingArea }}㎡</span>
                <span class="units" v-else>--</span>

              </div>
              <div class="box">
                <div class="msg">楼层:</div>

                <span class="units" v-if="assessmentDetail.floors">{{ assessmentDetail.floors }}</span>
                <span class="units" v-else>--</span>

              </div>

              <div class="box">
                <div class="msg">总楼层:</div>

                <span class="units" v-if="assessmentDetail.totalFloors">{{ assessmentDetail.totalFloors }}</span>
                <span class="units" v-else>--</span>

              </div>

              <div class="box">
                <div class="msg">户型:</div>

                <span class="units">{{ houseStyle }}</span>

              </div>

              <div class="box">
                <div class="msg">朝向:</div>

                <span class="units" v-if="assessmentDetail.orientation">{{ assessmentDetail.orientation }}</span>
                <span class="units" v-else>--</span>

              </div>

              <div class="box">
                <div class="msg">
                  建成年代:
                </div>
                <span class="units" v-if="assessmentDetail.completionYear">{{
                  assessmentDetail.completionYear
                }}</span>
                <span class="units" v-else>--</span>

              </div>
            </div>

          </div>

          </Col>
          <Col span="11">
          <div class="BmapMin" id="BmapMin"></div>
          </Col>
        </Row>
      </div>

      <!-- <div class="color-box">
        <div class="result">
          <Row :gutter="16" index="">
            <Col span="24">
            <div class="top">
              <div class="title">
                <span> {{ assessmentDetail.evlTitle }}</span>
              </div>
              <div class="time">提交时间：{{ assessmentDetail.assessTime | filter_assessTime }}</div>
            </div>
            <div class="center-box">
              <div class="flex-box" v-if="(assessmentDetail.assessResult == 1)">
                <div class="price">
                  <span class="price1">总价 </span>
                  <span class="price-num"> {{ assessmentDetail.evaluateTotalPrice.toFixed(2) }} </span>
                  <span class="unit"> 万元</span>
                </div>
                <div class="price">
                  <span class="price1">单价 </span>
                  <span class="price-num"> {{ assessmentDetail.evaluatePrice.toFixed(0) }} </span>
                  <span class="unit"> （元/㎡）</span>
                </div>
              </div>
              <div class="flex-box" v-if="(assessmentDetail.assessResult == 3)">
                <div class="price">
                  <span class="price1">参考总价 </span>
                  <span class="price-num"> {{ assessmentDetail.evaluateTotalPrice.toFixed(2) }} </span>
                  <span class="unit"> 万元</span>
                </div>
                <div class="price">
                  <span class="price1">参考单价 </span>
                  <span class="price-num"> {{ assessmentDetail.evaluatePrice.toFixed(0) }} </span>
                  <span class="unit"> （元/㎡）</span>
                </div>
              </div>
            </div>
            </Col>
            <Col span="24">
            <div class="detail">
              <div class="item">
                <div class="box">
                  <div class="msg" style="width: 54px;">面积</div>
                  <span class="units" v-if="assessmentDetail.buildingArea">{{ assessmentDetail.buildingArea }}㎡</span>
                  <span class="units" v-else>--</span>
                </div>
                <div class="box">
                  <div class="msg" style="width: 36px;">楼层</div>
                  <span class="units" v-if="assessmentDetail.floors">{{ assessmentDetail.floors }}层</span>
                  <span class="units" v-else>--</span>
                </div>
                <div class="box">
                  <div class="msg" style="width: 54px;">总楼层</div>
                  <span class="units" v-if="assessmentDetail.totalFloors">{{ assessmentDetail.totalFloors }}层</span>
                  <span class="units" v-else>--</span>
                </div>
              </div>
              <div class="item">
                <div class="box">
                  <div class="msg">户型</div>
                  <span class="units">{{ houseStyle }}</span>
                </div>
                <div class="box">
                  <div class="msg" style="width: 36px;">朝向</div>
                  <span class="units" v-if="assessmentDetail.orientation">{{ assessmentDetail.orientation }}</span>
                  <span class="units" v-else>--</span>
                </div>
                <div class="box">
                  <div class="msg">建成年代</div>
                  <span class="units" v-if="assessmentDetail.completionYear">{{ assessmentDetail.completionYear
                  }}</span>
                  <span class="units" v-else>--</span>
                </div>
              </div>
            </div>
            </Col>

          </Row>
        </div>
        <div>
          <Row>
            <Col span="24">
            <div class="BmapMin" id="BmapMin"></div>
            </Col>
          </Row>
        </div>

      </div> -->

      <!-- 参考实例 -->
      <div v-if="(exampleList.length > 0 || exampleListTow.length > 0)">
        <div class="example">
          <div>
            <div class="ex-title">成交案例</div>
            <Table :columns="exampleColumns" stripe v-if="exampleList.length > 0" :data="exampleList"></Table>
            <div class="no-data" v-else>
              <img :src="noDataImg" alt="">
              <div>暂无数据</div>
            </div>
          </div>
          <div>
            <div class="ex-title" style="margin-top: 48px;">挂牌案例</div>
            <Table :columns="exampleColumnsGuapai" stripe v-if="exampleListTow.length > 0" :data="exampleListTow">
            </Table>
            <div class="no-data" v-else>
              <img :src="noDataImg" alt="">
              <div>暂无数据</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 周边配套 -->
      <div style="margin-top: 110px;" v-if="showSurround">
        <div class="all-title">周边配套</div>
        <div class="surround">
          <div v-for="(item) in surroundList" :key="item.name" style="margin-bottom: 36px;">
            <div v-if="item.list.length > 0">
              <div class="surround-title">{{ item.name }}</div>
              <div class="surround-detail">
                <span v-for="(chid, index) in item.list" :key="index">{{ chid.name
                }}【{{ chid.detail_info.distance }}米】;</span>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- 水印 -->
      <div class="watermark" :style="watermarkStyle"></div>
    </div>
  </Modal>
</template>

<script>
import PriceBox from '@/views/pledge/components/PriceBox.vue'
import dayjs from 'dayjs'
import { setAppConfig, getLocalAppConfig, getConfigItem } from "@/utils/appConfig";

import {
  land_data_retrieve
} from '@/api/reLand.js'
import html2canvas from "html2canvas";
import jsPdf from "jspdf";
import { Row } from 'view-design';
export default {

  props: {
    pdfModel: {
      type: Boolean,
      required: true,
    },
    exampleList: {
      type: Array,
      default: () => ([

      ])
    },
    exampleListTow: {
      type: Array,
      default: () => ([

      ])
    },
    assessmentDetail: {
      type: Object,
      default: () => ({

      })
    },
    exampleColumns: {
      type: Array,
      default: () => ([
      ])
    },
    exampleColumnsGuapai: {
      type: Array,
      default: () => ([
      ])
    },
    showSurround: {
      type: Boolean,
      default: true
    },
    center: {
      type: Object,
      default: () => ({
        lng: 113.335593,
        lat: 23.119767,
      })
    },

  },
  components: {
    PriceBox
  },
  watch: {
    center: {
      handler: function (val, oldVal) {
        this.mapData.center = val
      },
      deep: true
    },

  },
  data() {
    return {
      isCreaMap: false,

      liveIcon: require("@/assets/image/map/localNew.png"),
      headImg: require("@/assets/image/pledge/point-line.png"),
      // center: {
      //   lng: 113.335593,
      //   lat: 23.119767,
      // },
      //地图信息
      mapData: {
        zoom: 17,
        center: this.center
      },
      noDataImg: require("@/assets/image/pledge/no_data.png"),


      tabList: [{
        name: '教育',
        keyWorld: ['幼儿园', '小学', '中学', '高等院校', '科研机构', '图书馆', '科技馆', '亲子教育', '培训机构'],
      }, {
        name: '医疗',
        keyWorld: ['综合医院', '三甲医院', '专科医院', '药店', '疗养院', '体检机构', '急救中心', '疾控中心', '医疗保健'],
      }, {
        name: '商业',
        keyWorld: ['购物', '酒店', '美食', '休闲娱乐', '银行', '写字楼'],
      }, {
        name: '交通',
        keyWorld: ['地铁站', '公交站', '火车站', '长途汽车站', '飞机场', '港口', '停车场'],
      }, {
        name: '其他',
        keyWorld: ['加油站', '液化气供应站', '垃圾场', '核电厂', '变电站', '殡仪服务', '化工厂', '危险品仓库', '屠宰场', '污水处理厂'],
      }],
      surroundList: [//后台获取的周边配套信息
        {
          name: '教育',
          list: [],
        },
        {
          name: '医疗',
          list: [],
        },
        {
          name: '商业',
          list: [],
        },
        {
          name: '交通',
          list: [],
        },
        {
          name: '其他',
          list: [],
        },
      ],
    }
  },
  filters: {
    filter_assessTime(val) {
      return dayjs(val).format('YYYY/MM/DD');
    }
  },
  computed: {
    showpdf: {
      get() {
        return this.pdfModel
      },
      set(newVal) {
        this.$parent.showpdfModel = newVal
      }

    },
    houseStyle() {
      let roomCnt = this.assessmentDetail.roomCnt ? this.assessmentDetail.roomCnt : 0
      let parlourCnt = this.assessmentDetail.parlourCnt ? this.assessmentDetail.parlourCnt : 0
      if (roomCnt == 0) return '--'
      if (parlourCnt == 0) return `${roomCnt}房`
      return `${roomCnt}房${parlourCnt}厅`
    },

    HaveLiftStyle() {//电梯
      let isHaveLift = this.assessmentDetail.isHaveLift
      if (isHaveLift === '') return '--'
      if (isHaveLift) {
        return '有'
      } else {
        return '无'
      }
    },
    watermarkStyle() {
      const cachedConfig = getLocalAppConfig();
			const style = {};
			
			if (cachedConfig.watermark) {
        style.backgroundImage = `url(${cachedConfig.watermark})`;
        style.backgroundRepeat = 'repeat';
        style.backgroundSize = '280px auto';
        style.opacity = 0.08;
			} 

			return style;
    }
  },

  mounted() {

  },
  methods: {
    async visibleChange(status) {//模态框状态改变
      if (status && !this.isCreaMap) {
        setTimeout(() => {
          this.loadMap(BMap)
          this.isCreaMap = true
        }, 500)
      }
      if (status) {

        this.$msg.success(
          {
            text: '报告已自动下载，请查看下载列表',
            duration: 3
          }
        )

        this.getSearchNearBy()

        setTimeout(() => {
          this.toImage()
        }, 1500)
      }
    },
    toImage() {
      // this.$btnlog(1015);
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.detail, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        // taintTest: false,
        imageTimeout: 0,
      }).then((canvas) => {
        // 把生成的base64位图片上传到服务器,生成在线图片地址
        this.htmlToPdf(canvas);
      });
    },
    async htmlToPdf(htmlCanvas) {
      // 将canvas对象转为pdf
      const pdf = this.canvasToPdf(htmlCanvas);
      // 通过浏览器下载pdf
      this.downPdf(pdf, "估价报告");
    },
    downPdf(pdfInstance, title) {
      // 文件名过长导致下载失败
      if (title.length > 50) {
        title = title.substring(title.length - 50);
      }

      pdfInstance.save(title + ".pdf", {
        returnPromise: true
      }).then(() => {
        // 搜狗浏览器下载机制问题暂时不关闭
        // if (!(navigator.userAgent.toLowerCase().indexOf("se 2.x") > -1)) {
        //     setTimeout(window.close, 300);
        // }
      });
    },
    canvasToPdf(htmlCanvas) {
      const canvasWidth = htmlCanvas.width;
      const canvasHeight = htmlCanvas.height;
      const imgBase64 = htmlCanvas.toDataURL("image/jpeg", 1.0);

      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      const imgWidth = 595.28;
      // 图片高度需要等比缩放
      const imgHeight = (595.28 / canvasWidth) * canvasHeight;

      let pageHeight = imgHeight; // pdf转化后页面总高度
      let position = 0;

      const pdfInstance = new jsPdf("", "pt", "a4");
      pdfInstance.setFontSize(12);

      if (imgHeight < 841.89) {
        pdfInstance.addImage(imgBase64, "JPEG", 0, 0, imgWidth, imgHeight);
      } else {
        while (pageHeight > 0) {
          pdfInstance.addImage(
            imgBase64,
            "JPEG",
            0,
            position,
            imgWidth,
            imgHeight
          );
          pageHeight -= 841.89;
          position -= 841.89;
          if (pageHeight > 0) {
            pdfInstance.addPage();
          }
        }
      }

      return pdfInstance;
    },

    loadMap(BMap) {//地图打点
      let that = this;
      that.map = new BMap.Map("BmapMin");
      const myPoint = new BMap.Point(
        that.mapData.center.lng,
        that.mapData.center.lat
      );

      let opts = {
        position: myPoint,
        offset: new BMap.Size(-20, -20)
      }
      let info = new BMap.Label('小区', opts)
      info.setContent(
        `<div class="map-info-box ">
          ${that.assessmentDetail.lpName}
          </div>`
      );
      info.setStyle({
        border: "none",
        borderRadius: "5px",
        backgroundColor: 'transparent',
      });

      // that.map.centerAndZoom(myPoint, 7);
      // 初始化地图， 设置中心点坐标和地图级别
      that.map.centerAndZoom(myPoint, that.mapData.zoom);
      that.map.disableDragging();     //禁止拖拽
      that.map.disableScrollWheelZoom();//禁止缩放
      const icon = new BMap.Icon(that.liveIcon, new BMap.Size(34, 58), {
        anchor: new BMap.Size(25, 60)
      });
      icon.setSize(new BMap.Size(34, 58));
      icon.setImageSize(new BMap.Size(34, 58));
      let marker = new BMap.Marker(myPoint, {
        icon,
      });
      marker.addEventListener("click", () => {
        that.map.centerAndZoom(myPoint, 17);
      });
      // that.map.addOverlay(marker);
      that.map.addOverlay(info);


    },

    getSearchNearBy() {//循环查询周边配套
      // this.surroundList = []
      this.tabList.map(item => {
        this.searchNearBy(item.name, item.keyWorld)

      })
    },
    //查询周边配套
    async searchNearBy(name, keyWorld) {
      let {
        lat,
        lng
      } = this.center
      let params = {
        radius: 3000,
        location: `${lat},${lng}`,
        query: keyWorld.join(','),
        // tag: keyWorld.join(','),
        page_num: 0,
        page_size: 20,
        filter: 'sort_name:distance|sort_rule:1',
        radius_limit: true,
        scope: 2
      }
      let data = await land_data_retrieve(params)
      let results = data.results.slice(0, 10)
      let obj =
      {
        name: name,
        list: results
      }

      this.surroundList = this.surroundList.map(item => {
        if (item.name == name) {
          item.list = results
        }
        return item
      })
      // this.markList = []
      // data.results.forEach((item, index) => {
      //   this.markList.push(item)
      // })
    },

  }
}
</script>

<style scoped lang="scss">
.pdf-body {
  width: 1440px;
  margin: auto;
  // background: #F1F6FF;
  background: #FFFFFF;
  padding-bottom: 24px;
  padding-top: 12px;
  position: relative;
  // padding:50px;
  // height: 900px;
  // overflow-y: scroll;
  //头部
  .head {
    width: 100%;
    // height: 197px;
    // background: #045AFC;
    font-size: 48px;
    font-family: PingFang SC-Bold, PingFang SC;
    // font-weight: bold;
    // color: #FFFFFF;
    color: #002C63;
    text-align: center;
    // line-height: 197px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-bottom: #045AFC solid 4px;
    padding-bottom: 38px;
    margin-bottom: 30px;
margin-top: 30px;
    .img-head {
      margin: 0 24px;
    }

    //  &:before {
    // content: "";
    //   background-image: url(~@/assets/image/pledge/point-line.png);

    // }
  }

  .all-title {
    width: 143px;
    // margin-top: 68px;
    margin-left: 24px;
    font-size: 18px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #262626;
    text-align: left;
    // border-left: 7px solid #045AFC;

  }

  .color-box {
    background: rgba(0, 119, 255, 0.04);

  }

  .result {
    padding: 24px;
    width: 100%;
    height: 408px;
    background-color: #fff;
    border-radius: 10px 10px 10px 10px;

    .top {

      .title {
        font-size: 20px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #404040;
        margin-bottom: 18px;
        position: relative;
      }

      .msg {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #92969B;


        .address {
          color: #737373;
          ;

        }
      }

    }

    .center-box {
      // padding-left: 24px;
      // padding-right: 36px;
      width: 100%;
      margin-top: 18px;
      height: 144px;
      background: #F5F6FC;
      border-radius: 12px;
      // padding-top: 24px;

      .flex-box {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left-box {
          display: flex;
          justify-content: space-between;

          width: 414px;
          margin-left: 110px;
        }

        .no-price {
          width: 100%;
          margin: auto;
          text-align: center;
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 32px;
          color: #000000;
          margin-top: 52px;

          .tips {
            font-family: PingFang SC Regular;
            font-size: 16px;
            font-weight: 300;
            line-height: 20px;
            text-align: center;
            letter-spacing: 0em;

            color: #999999;
          }
        }

        .right-box {
          // display: flex;
          // flex-direction: column-reverse;
          // justify-content: center;
          padding: 0;
          // width: 120px;
          margin-right: 40px;

          .top-bit {
            margin-top: 32px;
          }
        }
      }
    }

    .loan-box {
      display: flex;
      margin-top: 36px;
      align-items: center;

      .text {
        font-size: 16px;
        font-family: PingFangSC-Regular-, PingFangSC-Regular;
        font-weight: normal;
        color: #737373;
        margin-right: 16px;
      }

      .price {
        margin-left: 16px;
        margin-right: 7px;
        font-size: 20px;
        font-family: DINPro-Black, DINPro;
        font-weight: 900;
        color: #404040;
      }

      .unit {

        font-size: 20px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #404040;
      }
    }

    .announcement {
      margin-top: 20px;
      font-size: 16px;
      display: flex;
      // align-items: center;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #737373;

      img {
        width: 17px;
        height: 17px;
        margin-top: 5px;
        margin-right: 5px;
      }
    }

    .detail {
      margin-top: 38px;
      font-size: 16px;
      // margin-left: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #737373;

      .item {
        display: flex;
        margin-top: 18px;
        justify-content: space-between;
        align-items: center;

        .line {
          width: 1px;
          height: 30px;
          background: #D3D5DF;
          margin: 0 44px;
        }

        .box {
          // margin-right: 54px;
          // width: 160px;
          display: flex;
          // flex-direction: column;
          align-items: center;
          text-align: center;
color: #44474F;
          .msg {
            // width: 100%;
            // margin-top: 6px;
            // color: #92969B;
            font-size: 14px;
margin-right: 4px;
            // margin-right: 16px;
          }

          .units {
            font-family: PingFang SC-Bold, PingFang SC;
            // font-weight: bold;
            // color: #404040;
            font-size: 14px;
            // flex: 1;
            // width: 100%;
          }
        }

      }

    }

    #BmapMin {
      height: 360px;
      // min-width: 748px;
      border-radius: 10px;
      width: 100%;
      background: #eee;
    }
  }

  #BmapMin {
    height: 499px;
    // min-width: 748px;
    width: 100%;
    background: #eee;
  }



  // 参考案例
  .example {
    padding: 24px;
    width: 96%;
    margin: auto;
    margin-top: 24px;
    margin-bottom: 98px;
    height: 664px;
    // height: 328px;
    background: #FFFFFF;
    border-radius: 4px;

    .ex-title {
      width: 100%;
      height: 40px;
      text-align: left;
      font-size: 16px;
      font-family: PingFangSC-Regular-, PingFangSC-Regular;
      font-weight: normal;
      color: #404040;
      border-bottom: 1px solid #E7E7E7;
      margin-bottom: 22px;
    }

    .no-data {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 250px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #A6A6A6;
    }

  }

  //周边配套
  .surround {
    // padding: 24px;
    width: 96%;
    margin: auto;
    margin-top: 30px;

    // height: 381px;
    // height: 328px;
    height: 622px;
    background: #FFFFFF;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;

    .surround-title {
      color: #262626;
      font-weight: bold;
    }

    .surround-detail {

      color: #404040;

      span {
        margin-right: 10px;
      }
    }
  }

  // 使用声明

  .statement {
    padding: 24px;
    margin-top: 62px;
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #737373;

    .statement-title {
      font-size: 20px;
      font-family: PingFang SC-Bold;
      font-weight: bold;
      color: #262626;
    }

    .statement-detail {
      .con {
        text-indent: 2em;
      }
    }
  }

  //水印
  .watermark {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../../../assets/image/watermarkNew.png');
    background-repeat: repeat;
    background-size: 280px auto;
    background-position: center;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 99999;
    opacity: 0.08;
  }
}
</style>
